module.exports = __webpack_public_path__ + "static/img/px.png";